/**
 * @description Simple object check.
 * @param item
 * @returns {boolean}
 */
export default (item) => {
  return item && typeof item === 'object' && !Array.isArray(item);
};
